import { useContext } from "react";
import useSWR from "swr";

import { UserContext } from "../context";
import { URL, Fetcher as F } from "../api";

export const useChangeFoodVendorReason = () => {
  const {
    token: { access },
  } = useContext(UserContext);

  const { data = [] } = useSWR(
    access && [URL.changeFoodVendorReason],
    F.withToken,
    { revalidateOnFocus: false }
  );

  return data;
};
